module.exports = __webpack_public_path__ + "static/Party_Deck03A_copy-eebf760cea5b09c3bbf00034b40a3297.jpg";